window['$'] = window['jQuery'] = require('jquery');
window['numeral'] = require('numeral');
window['moment'] = require('moment');
window['_4'] = require('lodash4');

require('angular');
require('angular-animate');
require('angular-sanitize');
require('angular-ui-router');
require('angular-messages');
require('angular-aria');

var whatInput = (window.whatInput = require('./vendor_frozen/lib/what-input'));

require('ui-router-extras/release/modular/ct-ui-router-extras.core.min');
require('ui-router-extras/release/modular/ct-ui-router-extras.dsr.min');
require('ui-router-extras/release/modular/ct-ui-router-extras.sticky.min');

require('ui-ng-ax');
require('ui-ng-browser-detect');
require('ui-ng-core-bootstrap');
require('ui-ng-delegate');
require('ui-ng-notification');
require('ui-ng-polymer');
require('ui-ng-popover');
require('ui-ng-progress');
require('ui-ng-session-timer');
require('ui-ng-tooltip');
require('ui-ng-university-branding');
require('ui-ng-university-text');

require('utility-ng-configuration');
require('utility-ng-database');
require('utility-ng-enumeration');
require('utility-ng-interface');
require('utility-ng-kernel');
require('utility-ng-log');
require('utility-ng-network-cache');
require('utility-ng-progression');
require('utility-ng-time');
require('biz-ng-career-details');

angular.module('vendor', [
  'ui-ng-ax',
  'ui-ng-browser-detect',
  'ui-ng-core-bootstrap',
  'ui-ng-delegate',
  'ui-ng-notification',
  'ui-ng-polymer',
  'ui-ng-popover',
  'ui-ng-progress',
  'ui-ng-session-timer',
  'ui-ng-tooltip',
  'ui-ng-university-branding',
  'ui-ng-university-text',
  'utility-ng-configuration',
  'utility-ng-database',
  'utility-ng-enumeration',
  'utility-ng-interface',
  'utility-ng-kernel',
  'utility-ng-log',
  'utility-ng-network-cache',
  'utility-ng-progression',
  'utility-ng-time',
  'biz-ng-career-details'
]);

require('./lib/anonymous_landing/main');
require('./lib/user_app/main');
require('./lib/global/main');
require('./lib/checklist/main');
require('./lib/resources/main');
require('./lib/transfer/main');
require('./lib/sitesetup/main');
require('./lib/authentication/main');
require('./lib/constants/main');



// WEBPACK FOOTER //
// ./app/index.ts